import React from 'react';
import { Phone, CheckCircle2, Star, Shield, ThumbsUp, Zap } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <div className="relative w-full" data-id="element-123">
      {/* Bold, modern background */}
      <div className="absolute inset-0 z-0" data-id="element-124">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2000&auto=format&fit=crop')"
      }} data-id="element-125" />
        {/* Dark/Red overlay to prevent washed out look and keep it masculine */}
        <div className="absolute inset-0 bg-dark/80 mix-blend-multiply" data-id="element-126" />
        <div className="absolute inset-0 bg-gradient-to-r from-dark via-dark/90 to-accent/20" data-id="element-127" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-dark/50 to-dark" data-id="element-128" />
      </div>

      <div className="relative z-10 container mx-auto px-4 pt-24 pb-20 md:pt-32 md:pb-28 flex flex-col items-center text-center" data-id="element-129">
        <div className="inline-flex items-center justify-center p-3 bg-accent/10 rounded-full mb-6 border border-accent/30" data-id="element-130">
          <Zap className="h-8 w-8 text-accent" data-id="element-131" />
        </div>

        <h1 className="font-display text-4xl md:text-7xl lg:text-8xl text-white uppercase tracking-wide mb-6 leading-[1.1] max-w-5xl" data-id="element-132">
          Industrial Strength <span className="text-accent" data-id="element-133">Cleaning</span>
        </h1>

        <p className="text-lg md:text-xl text-slate-300 max-w-2xl mb-10 font-medium" data-id="element-134">
          Professional pressure washing and soft washing for homes, driveways,
          and businesses across the Phoenix East & West Valley.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto mb-8" data-id="element-135">
          <Button className="w-full sm:w-auto h-14 px-8 bg-accent hover:bg-accent-light text-white font-bold uppercase tracking-wider text-lg rounded-md" data-id="element-136">
            Book Online
          </Button>
          <Button variant="outline" className="w-full sm:w-auto h-14 px-8 border-2 border-white text-white hover:bg-white/10 font-bold uppercase tracking-wider text-lg rounded-md bg-transparent" data-id="element-137">
            <Phone className="mr-2 h-5 w-5" data-id="element-138" />
            Call 208-716-7525
          </Button>
        </div>

        <div className="flex items-center gap-2 text-sm md:text-base text-slate-400 font-medium" data-id="element-139">
          <span data-id="element-140">Locally owned</span>
          <span className="text-accent" data-id="element-141">•</span>
          <span data-id="element-142">Fully insured</span>
          <span className="text-accent" data-id="element-143">•</span>
          <span data-id="element-144">5-star rated</span>
        </div>
      </div>

      <div className="relative z-10 w-full bg-dark border-y border-accent/20 py-6" data-id="element-145">
        <div className="container mx-auto px-4" data-id="element-146">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-147">
            <div className="flex flex-col items-center gap-2" data-id="element-148">
              <CheckCircle2 className="h-6 w-6 text-accent" data-id="element-149" />
              <span className="text-sm font-bold text-slate-300 uppercase tracking-wider" data-id="element-150">
                2,000+ Properties Cleaned
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-151">
              <Star className="h-6 w-6 text-accent-light" data-id="element-152" />
              <span className="text-sm font-bold text-slate-300 uppercase tracking-wider" data-id="element-153">
                5-Star Rated
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-154">
              <Shield className="h-6 w-6 text-accent" data-id="element-155" />
              <span className="text-sm font-bold text-slate-300 uppercase tracking-wider" data-id="element-156">
                Licensed & Insured
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-157">
              <ThumbsUp className="h-6 w-6 text-accent-light" data-id="element-158" />
              <span className="text-sm font-bold text-slate-300 uppercase tracking-wider" data-id="element-159">
                Free Estimates
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}